import { args } from '../../../common/args';
export const onInviteEmptyStateEligibilityResponse = {
  onInviteEmptyStateEligibilityResponse: {
    args: {
      shouldShowEmptyState: args.bool()
    }
  }
};